// extracted by mini-css-extract-plugin
export var overlay = "styles-module--overlay--2epbb";